module.exports = __webpack_public_path__ + "static/media/contactCard.fc4084b2.svg";